<div
  class="row"
  [ngClass]="{'highlight': this.isHighlighted()}"
  >
  <div
    class="col-1 cursor-pointer "
    style="width: 32px; height: 32px; border-radius: 5px; margin-top: -4px;"
    [ngStyle]="getActionStyle(logEntry.action)"
    id="symbol"
    (click)="this.toggleDetails(logEntry)"
    >
    <ng-container *ngTemplateOutlet="actionIcon; context: logEntry"></ng-container>
  </div>
  <div class="col-11">
    <div
      (click)="this.toggleDetails(logEntry)"
      class="cursor-pointer"
      >
      <i
        class="ri-lg"
        [ngClass]="{
                  'ri-arrow-down-s-line': this.selectedEntryiesForDetails.includes(logEntry.created),
                  'ri-arrow-right-s-line': !this.selectedEntryiesForDetails.includes(logEntry.created)
                }"
        ></i><span [innerHTML]="logEntry.title"></span><br class="d-md-none d-inline">
        <small class="text-muted float-none float-md-end">{{logEntry.created | date: 'dd/MM/yyyy HH:mm'}}</small>
      </div>
      @if (this.selectedEntryiesForDetails.includes(logEntry.created)) {
        <div>{{logEntry.action}}</div>
        <small [innerHTML]="logEntry.reason"></small><br>
        <b>Dauer:</b> {{logEntry.executionDuration | msFormat}}<br>
        <ng-container *ngTemplateOutlet="explanationParser; context: {$implicit: logEntry}"></ng-container>
      }
      <hr class="d-md-block d-none">
    </div>
  </div>

  <ng-template
    #actionIcon
    let-action="action"
    >
    @switch (action) {
      @case ('avatarbotNewSession') {
        <i class="ri-add-circle-fill"></i>
      }
      @case ('chatcompletion') {
        <i class="ri-loader-2-fill"></i>
      }
      @case ('heygen_streaming_avatar') {
        <i class="ri-account-circle-fill"></i>
      }
      @case ('Membot call to chat/botid done') {
        <i class="ri-database-2-fill"></i>
      }
      @case ('texttospeech') {
        <i class="ri-speak-fill"></i>
      }
      @case ('ThreadbotServiceCreatedThread') {
        <i class="ri-add-circle-fill"></i>
      }
      @case ('ThreadbotServiceUpdatedAssistent') {
        <i class="ri-user-settings-fill"></i>
      }
      @case ('ThreadbotService') {
        <i class="ri-service-fill"></i>
      }
      @case ('ThreadbotServiceCreatedAssistent') {
        <i class="ri-user-star-fill"></i>
      }
      @case ('ToolServiceToolNotFound') {
        <i class="ri-user-unfollow-fill"></i>
      }
      @case ('tool has Contents from url') {
        <i class="ri-file-text-line"></i>
      }
      @case ('tool Has outputs') {
        <i class="ri-download-cloud-2-fill"></i>
      }
      @case ('toolrunerror') {
        <i class="ri-error-warning-fill"></i>
      }
      @case ('tool runsMarkdown') {
        <i class="ri-markdown-fill"></i>
      }
      @case ('tool runstart') {
        <i class="ri-play-circle-fill"></i>
      }
      @case ('toolAddDatatrunkTool') {
        <i class="ri-tools-line"></i>
      }
      @case ('CustomTool triggered') {
        <i class="ri-exchange-2-fill"></i>
      }
      @case ('CustomTool finish') {
        <i class="ri-swap-2-fill"></i>
      }
      @case ('skillenabled') {
        <i class="ri-instance-fill"></i>
      }
      @case ('skilldisabled') {
        <i class="ri-instance-fill"></i>
      }
      @case ('ToolsAvailable') {
        <i class="ri-tools-line"></i>
      }
      @case ('Waiting RunStart @OpenAI') {
        <i class="ri-openai-fill"></i>
      }
      @case ('Requesting Run @OpenAI') {
        <i class="ri-openai-fill"></i>
      }
      @case ('skillsforced') {
        <i class="ri-hammer-line"></i>
      }
      @case ('doc-search') {
        <i class="ri-file-search-fill"></i>
      }
      @case ('mcp') {
        <i class="ri-plug-2-fill"></i>
      }
      @default {
        <p>
          ICON NOT FOUND: {{action}}
        </p>
      }
    }
  </ng-template>


  <ng-template
    #explanationParser
    let-entry
    >
    @switch (entry.action) {
      @case ('avatarbotNewSession') {
        <b>Heygen-Response: </b>
        <ul>
          <li><b>Code: </b>{{entry.explanation.heygenResponse.code}}</li>
          <li><b>Message: </b>{{entry.explanation.heygenResponse.message}}</li>
        </ul>
      }
      @case ('chatcompletion') {
        <b>Model:</b> {{entry.model}}<br>
        <b>Token:</b>
        <ul>
          <li><b>Prompt Token:</b> {{entry.usage.prompt_tokens}}</li>
          <li><b>Completion Token:</b> {{entry.usage.completion_tokens}}</li>
          <li><b>Insgesamt:</b> {{entry.usage.total_tokens}}</li>
          <li></li>
        </ul>
      }
      @case ('heygen_streaming_avatar') {
        <b>Model:</b> {{entry.model}}<br>
        <b>Konvertierung:</b> {{entry.conversionMS | msFormat}}<br>
        <b>Response-Code:</b> {{entry.explanation.heygenResponse.code}}<br>
        <b>Response-Message:</b> {{entry.explanation.heygenResponse.message}}<br>
        <b>Text:</b> {{entry.explanation.text}}<br>
      }
      @case ('Membot call to chat/botid done') {
      }
      @case ('texttospeech') {
        <b>Model:</b> {{entry.model}}<br>
        <b>Characters:</b> {{entry.characters}}<br>
      }
      @case ('ThreadbotServiceCreatedThread') {
      }
      @case ('ThreadbotServiceUpdatedAssistent') {
        <b>Bot: </b>
        <ul>
          <li><b>Name:</b> {{entry.explanation.updater.name}}</li>
          <li><b>Temperature:</b> {{entry.explanation.updater.temperature}}</li>
          <li><b>Model:</b> {{entry.explanation.updater.model}}</li>
          @if (entry.explanation.updater.instructions) {
            <li><b>Instructions:</b>
          {{entry.explanation.updater.instructions}}</li>
        }
        @if (entry.explanation.updater.tools.lenth > 0) {
          <li><b>Tools:</b> @for(tool of
          entry.explanation.updater.tools; track
          $index; let i = $index){
          {{tool.type}} @if(i <
          entry.explanation.updater.tools.length-1){,}
        }
        </li
        >
      }
      <li><b>Assistant ID:</b> {{entry.explanation.assistant?.id}}</li>
    </ul>
  }
  @case ('ThreadbotService') {
    <b>Explanation: </b>{{entry.explanation}}
  }
  @case ('ThreadbotServiceCreatedAssistent') {
    <b>Bot: </b>
    <ul>
      <li><b>Name:</b> {{entry.explanation.createParams.name}}</li>
      <li><b>Temperature:</b> {{entry.explanation.createParams.temperature}}</li>
      <li><b>Model:</b> {{entry.explanation.createParams.model}}</li>
      @if (entry.explanation.createParams.instructions) {
        <li><b>Instructions:</b>
      {{entry.explanation.createParams.instructions}}</li>
    }
    @if (entry.explanation.createParams.tools.lenth > 0) {
      <li><b>Tools:</b> @for(tool of
      entry.explanation.updater.tools;
      track
      $index; let i = $index){
      {{tool.type}} @if(i <
      entry.explanation.createParams.tools.length-1){,}
    }
    </li
    >
  }
</ul>
}
@case ('ToolServiceToolNotFound') {
  <b>Bot: </b>
  <ul>
    <li><b>Name:</b> {{entry.explanation.botConfig.name}}</li>
    <li><b>Temperature:</b> {{entry.explanation.botConfig.temperature}}</li>
    <li><b>Model:</b> {{entry.explanation.botConfig.model}}</li>
  </ul>
}
@case ('tool has Contents from url') {
  <b>URL:</b> {{entry.explanation.calledUrl}}<br>
  <b>Content:</b> {{entry.explanation.content}}
}
@case ('tool Has outputs') {
  <b>Output:</b> <span [innerHTML]="entry.explanation"></span>
}
@case ('toolrunerror') {
  <b>Error:</b> {{entry.explanation}}
}
@case ('tool runsMarkdown') {
  <b>URL:</b> {{entry.explanation.calledUrl}}<br>
  <b>Markdown:</b> {{entry.explanation.markdown}}
}
@case ('tool runstart') {
  <b>Output:</b> {{entry.explanation}}
}
@case ('toolAddDatatrunkTool') {
}
@case ('CustomTool triggered') {
  <b>Output:</b> {{entry.explanation}}
}
@case ('CustomTool finish') {
  <b>Output:</b> {{entry.explanation}}
}
@case ('skillenabled') {
  <b>Aktiviert:</b><span [innerHTML]="entry.explanation"></span>
}
@case ('skilldisabled') {
  <b>Deaktiviert:</b><span [innerHTML]="entry.explanation"></span>
}
@case ('ToolsAvailable') {
}
@case ('Waiting RunStart @OpenAI') {
}
@case ('Requesting Run @OpenAI') {
}
@case ('skillsforced') {
}
@case ('doc-search') {
  <pre
    style="white-space: pre-wrap; font-size: 0.75rem; background: #f8f9fa; padding: 0.5rem; border-radius: 4px; max-height: 400px; overflow-y: auto;"
  >{{entry.explanation}}</pre>
}
@case ('mcp') {
  <span [innerHTML]="entry.explanation"></span>
}
@default {
  <p>
    {{entry.action}} IS NOT IMPLEMENTED
  </p>
}
}
</ng-template>